
import * as style from './style.css';
import { IColumnOrder, IOrderModel, IOrderOption } from '../../../framework/framework/index/order/IOrderModel';
import { ActionT } from '../../../framework/framework/components/Types';
import { MenuItem } from '@material-ui/core';
import { SelectComp } from '../../../components/select/SelectComp';
import React = require('react');

interface IProps {
    orderModel: IOrderModel;
    onOrderChange: ActionT<IColumnOrder[]>;
}

interface IState { }

export default class CatalogSortOrder extends React.Component<IProps, IState> {
    render() {
        let value = '0';
        if (this.props.orderModel && this.props.orderModel.order[0]) {
            value = this.props.orderModel.order[0].order.toString();
        }

        return (
            <div className={style.orderWrapper}>
                <div className={style.priceWrapper}>

                    <div>
                        Cena:
                    </div>
                    <SelectComp value={value}
                        variant={'outlined'}
                        onChange={(e) => this.handleChange(e)}
                    >
                        <MenuItem value={'0'}>Domyślnie</MenuItem>
                        <MenuItem value={'1'}>Od najtańszych</MenuItem>
                        <MenuItem value={'2'}>Od najdroższych</MenuItem>
                    </SelectComp>
                </div>
            </div>);
    }

    handleChange(event) {
        const value = parseInt(event.target.value);
        const columns = [];
        switch (value) {
            case 1:
                columns.push({ columnName: 'Name', order: IOrderOption.Ascending } as IColumnOrder);
                break;
            case 2:
                columns.push({ columnName: 'Name', order: IOrderOption.Descending } as IColumnOrder);
                break;
        }
        this.props.onOrderChange(columns);
    }
}
